import apiClient from './client';
import { ActorArchiveResponseMessage } from '@/types/ActorArchiveResponse';

/**
 * Fetches current actor (user) archive metadata from the server.
 */
export async function fetchActorArchive(): Promise<ActorArchiveResponseMessage> {
  const response = await apiClient.get<ActorArchiveResponseMessage>(
      '/secure/actor/archive'
  );
  return response.data;
}
